import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import AntiFilterContainer from "Containers/AntiFilter/AntiFilterContainer";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { List } from "./Tariffs";
import Metrika from "Services/Metrika";
import { YANDEX_TARGETS } from "Constants/metriks/yandex-targets";
import { ToogleRatesMobile } from "ComponentsUI/Toggle";

const Page = (props) => {
	const {
		ApplicationModel: {
			text,
			commonViewModel,
			siteConfig: {
				settings: { mobile_tariffs_mode = "list" },
			},
		},
	} = props;

	useEffect(() => {
		Metrika.getInstance().yandex.sendEvent(YANDEX_TARGETS.OPEN_RATESMOBILE_REGION, []);
	}, [props.match.params.tagCode]);

	// Закрыть модальное окно, если оно открыто во время перехода на данную страницу
	useEffect(() => {
		const modal = props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}, [props.match.url]);

	return (
		<PaddingBottom>
			<ToogleRatesMobile
				commonViewModel={commonViewModel}
				page={commonViewModel.ratesMobilePage}
				text={text}
				mobileTariffsMode={mobile_tariffs_mode}
			/>
			{commonViewModel.ratesMobilePage.includes("antifilter") && <AntiFilterContainer />}
			{commonViewModel.ratesMobilePage.includes("list") && <List />}
		</PaddingBottom>
	);
};

export default withRouter(withDefaultParams(inject("ApplicationModel")(observer(Page))));
